// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"3a8e2718","255":"c0b5db25","511":"ec62cfc2","673":"9423981a","767":"cac30d56"}[chunkId] + ".chunk.js";
};